import React, { useContext, useState, useEffect } from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../../helpers/colors';
import { useTranslation } from 'react-i18next';
import { audioDescription } from '../../helpers/audioDescription';
import { AppContext } from '../../AppContext';
import { IconButton, Button, Typography, Tooltip, Snackbar, FormControlLabel, Switch, FormControl } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
        adjustButton: {
            color: colors.black,
            backgroundColor: colors.lightGrey
        },
        acceptButton: {
            marginLeft: 10,
            color: colors.black,
            backgroundColor: colors.white
        },
        closeButton: {
            marginLeft: 10,
            color: colors.white
        }
    })
)

export const CookieConsent = React.memo(() => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const {t} = useTranslation();
    const { speak, cancel } = useSpeechSynthesis();

    const { cookieConsent, setCookieConsent, isAudiodescription } = useContext(AppContext);

    const [analytics, setAnalytics] = useState(cookieConsent?.analytics);

    useEffect(() => {
        setAnalytics(cookieConsent?.analytics);
    }, [cookieConsent]);

    const handleAcceptSelected = () => {
        const newCookieConsent = {
            isOpen: false,
            isSave: true,
            necessary: true,
            analytics: analytics
        }
        localStorage.setItem("cookie_consent", JSON.stringify(newCookieConsent));
        setCookieConsent(newCookieConsent);
    }

    const handleAcceptAll = () => {
        const newCookieConsent = {
            isOpen: false,
            isSave: true,
            necessary: true,
            analytics: true
        }
        localStorage.setItem("cookie_consent", JSON.stringify(newCookieConsent));
        setCookieConsent(newCookieConsent);
    }

    const handleClose = () => {
        setCookieConsent(prev => ({...prev, isOpen: false}));
    }

    return (
        <Snackbar
            open={cookieConsent?.isOpen}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            message={
                <>
                    <Typography
                        variant='body2'
                        onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.text'), t('lang'), isAudiodescription)}
                    >
                        {t('cookieConsentBaner.text')}
                    </Typography>
                    <FormControl>
                        <FormControlLabel
                            label={t('cookieConsentBaner.necessaryCookies')}
                            onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.necessaryCookies') + t('cookieConsentBaner.privacyPolicy2'), t('lang'), isAudiodescription)}
                            style={{cursor: 'default'}}
                            control={
                                <Switch
                                    checked={true}
                                    color="secondary"
                                    style={{cursor: 'default'}}
                                />
                            }
                        />
                        <FormControlLabel
                            label={t('cookieConsentBaner.analyticCookies')}
                            onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.analyticCookies') + t('cookieConsentBaner.privacyPolicy2'), t('lang'), isAudiodescription)}
                            control={
                                <Switch
                                    checked={analytics}
                                    onChange={e => setAnalytics(e.target.checked)}
                                    color="primary"
                                />
                            }
                        />
                    </FormControl>
                    <Typography
                        variant='body2'
                        onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.privacyPolicy1') + t('cookieConsentBaner.privacyPolicy2'), t('lang'), isAudiodescription)}
                    >
                        {t('cookieConsentBaner.privacyPolicy1')}<a target="_blank" href="/polityka-prywatnosci-i-plikow-cookies.pdf" style={{ color: '#93c5fd', marginLeft: 6 }}>{t('cookieConsentBaner.privacyPolicy2')}</a>.
                    </Typography>
                </>
            }
            action={
                <>
                    <Button
                        size="small"
                        variant="contained"
                        className={classes.adjustButton}
                        onClick={handleAcceptSelected}
                        onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.acceptSelectedButton'), t('lang'), isAudiodescription)}
                    >
                        {t('cookieConsentBaner.acceptSelectedButton')}
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        className={classes.acceptButton}
                        onClick={handleAcceptAll}
                        onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.acceptAllButton'), t('lang'), isAudiodescription)}
                    >
                        {t('cookieConsentBaner.acceptAllButton')}
                    </Button>
                    <Tooltip
                        title={t('cookieConsentBaner.closeButton')}
                    >
                        <IconButton
                            size="small"
                            className={classes.closeButton}
                            onClick={handleClose}
                            onPointerEnter={() => audioDescription(cancel, speak, t('cookieConsentBaner.closeButton'), t('lang'), isAudiodescription)}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </>
            }
        />
    )
})
